import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { compradores } from '../data/content';
const MINUTES = [2, 4, 5, 7, 8, 11, 13, 16, 19, 23];

/**
 * Rotating social-proof notification: "X from Y just bought the guide".
 */
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const schedule = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(i => (i + 1) % compradores.length);
        }, 5200);
      }, delay);
    };
    schedule(index === 0 ? 6000 : 12000 + Math.random() * 8000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  const persona = compradores[index];
  const minutos = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-199" data-mp="1151xjzwzatmy">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -24,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[340px]" role="status" aria-live="polite" data-id="element-200" data-mp="1fuhaabzocyjn">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-800/10 bg-white p-3 shadow-[0_16px_40px_-12px_rgba(11,19,48,0.35)]" data-id="element-201" data-mp="x5ko6veflcci">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-202" data-mp="s8aqksgw1udl" />
            <div className="min-w-0 flex-1" data-id="element-203" data-mp="23m66i3fma75v">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-204" data-mp="23nhbu7opnmz3">
                {persona.nombre} <span className="font-medium text-navy-800/70" data-id="element-205" data-mp="2aobbih2afotc">desde {persona.pais}</span>
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-navy-800/80" data-id="element-206" data-mp="2fpqzohzribfy">
                acaba de comprar <span className="font-semibold text-violet-600" data-id="element-207" data-mp="2kko5zh5nq6p5">Ruta Fertilidad Masculina</span>
              </p>
              <p className="mt-1 text-[10px] font-medium uppercase tracking-wide text-navy-800/45" data-id="element-208" data-mp="2pjhjh9ky1xpb">
                hace {minutos} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="rounded-full p-1 text-navy-800/40 transition-colors hover:bg-navy-800/5 hover:text-navy-900" data-id="element-209" data-mp="1wxg0oz88axn4">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-210" data-mp="196srmamku1yz" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}